class AccordionKlaviyoForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.emailCheck()
    this.setCountryCode()
  }

  setupListeners () {
    super.setupListeners()

    this.handleSubmit = this.handleSubmit.bind(this)
    this.emailCheck = this.emailCheck.bind(this)
    this.onVariantChanged = this.onVariantChanged.bind(this)

    this.listeners.add(this.els.form.element, 'submit', this.handleSubmit)
    this.listeners.add(this.els.email.element, 'input', this.emailCheck)
    this.listeners.add(this.els.email.element, 'change', this.emailCheck)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT.OPTION_CHANGED,
      this.onVariantChanged,
    )
  }

  onVariantChanged (event) {
    if (!event.detail.variant) return

    this.els.variantId.element.value = event.detail.variant?.id
    this.els.variantSku.element.value = event.detail.variant?.sku
  }

  emailCheck () {
    const emailValue = this.els.email.element.value

    if (emailValue && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
      this.els.submit.element.disabled = false
    } else {
      this.els.submit.element.disabled = true
    }
  }

  setCountryCode () {
    const countryCode =
      window.localStorage.getItem('PP-BAO-localization') || ''

    if (countryCode) {
      this.els.countryCode.element.value = countryCode
    }
  }

  async handleSubmit (event) {
    event.preventDefault()

    const customerEmail = this.els.email?.element?.value
    if (!customerEmail) return

    const formData = new FormData(this.els.form.element)
    const variantId = formData.get('notify_me_variant_id')
    const variantSku = formData.get('notify_me_variant_sku')
    const productId = this.dataset.productId

    let listId = window.theme.klaviyo.newsletterListId

    const customerCountry = this.dataset?.country || null
    if (customerCountry) {
      switch (customerCountry) {
        case 'Germany':
          listId = 'SF5ivA'
          break
        case 'South Korea':
          listId = 'TvmRXw'
          break
      }
    }

    try {
      // Step 1: Subscribe to back-in-stock
      await this.subscribeBackInStock(
        customerEmail,
        variantId,
        variantSku,
        productId,
      )

      // Step 2: Optional newsletter subscription if checkbox checked
      const newsletterOptIn = formData.get('notify_me_subscribe') === 'true'
      if (newsletterOptIn) {
        await this.subscribeNewsletter(customerEmail, listId)
      }

      // Show success message
      this.els.form.element.setAttribute('aria-hidden', true)
      this.els.submitted.element.setAttribute('aria-hidden', false)

      window.BAO.dispatchEvent(window.BAO.EVENTS.KLAVIYO.FORM_SUBMITTED, {
        customerEmail,
      })

      // Redirect after delay
      setTimeout(() => {
        window.location.href = this.els.submittedLink.element.href
      }, this.dataset.delay || 5000)
    } catch (error) {
      console.error('Klaviyo back-in-stock error:', error)
      // TODO: Show error message to user
    }
  }

  async subscribeBackInStock (email, variantId, variantSku, productId) {
    // Update profile with custom properties first
    await this.updateProfileProperties(email)

    const bodyData = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: { email },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$custom:::$default:::v_${variantSku}`,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        revision: window.theme.klaviyo.apiVersion,
        'content-type': 'application/json',
      },
      body: JSON.stringify(bodyData),
    }

    const response = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
      options,
    )

    if (!response.ok) {
      const data = await response.json()
      throw data.errors || new Error(`API returned ${response.status}`)
    }

    return response
  }

  async updateProfileProperties (email) {
    const countryCode = window.localStorage.getItem('PP-BAO-localization')
    const latestStorefront = window.theme.latestStorefront

    if (!countryCode && !latestStorefront) return

    const properties = {}
    if (countryCode) {
      properties.CountryCode = countryCode
    }
    if (latestStorefront) {
      properties['Latest StoreName'] = latestStorefront
    }

    const bodyData = {
      data: {
        type: 'profile',
        attributes: {
          email,
          properties,
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        revision: window.theme.klaviyo.apiVersion,
        'content-type': 'application/json',
      },
      body: JSON.stringify(bodyData),
    }

    const response = await fetch(
      `https://a.klaviyo.com/client/profiles/?company_id=${window.theme.klaviyo.apiKey}`,
      options,
    )

    if (!response.ok) {
      const data = await response.json()
      console.error('Profile update failed:', data.errors)
    }

    return response
  }

  async subscribeNewsletter (email, listId) {
    const profileAttributes = {
      email,
      subscriptions: {
        email: {
          marketing: {
            consent: 'SUBSCRIBED',
          },
        },
      },
    }

    const bodyData = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes,
            },
          },
          custom_source: 'Back In Stock Newsletter Opt-in',
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: window.theme.klaviyo.apiVersion,
        'content-type': 'application/vnd.api+json',
      },
      body: JSON.stringify(bodyData),
    }

    const response = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
      options,
    )

    if (!response.ok) {
      const data = await response.json()
      throw (
        data.errors ||
        new Error(`Newsletter subscription failed: ${response.status}`)
      )
    }

    return response
  }
}

if (!customElements.get('accordion-klaviyo-form')) {
  customElements.define('accordion-klaviyo-form', AccordionKlaviyoForm)
}
